<template>
    <StartModal v-model="startModalState" @validated="(data) => startModalEvent(data)"
        @closed="closeModal('StartModal')" :group-name="groupName"/>
    <LoginModal v-model="loginModalState" :form-data-prop="formData" @closed="closeModal('LoginModal')" />
    <RegisterModal v-model="registerModalState" :form-data-prop="formData" @closed="closeModal('RegisterModal')" />
</template>

<script>
import LoginModal from './CheckoutProcess/LoginModal';
import RegisterModal from './CheckoutProcess/RegisterModal';
import StartModal from './CheckoutProcess/StartModal';

export default {
    expose: ['showModal'],
    components: {
        LoginModal,
        RegisterModal,
        StartModal,
    },
    props: {
        groupName: String,
    },
    data() {
        return {
            activeModal: false,
            formData: {},
        };
    },
    methods: {
        startModalEvent(data) {
            this.formData = { ...this.formData, ...data.formData, };
            this.showModal(data.nextModal);
        },
        showModal(modal) {
            this.activeModal = modal;
        },
        closeModal(modal) {
            if (this.activeModal == modal) {
                this.activeModal = false;
            }
        },
    },
    computed: {
        startModalState() {
            return this.activeModal == 'StartModal';
        },
        loginModalState() {
            return this.activeModal == 'LoginModal';
        },
        registerModalState() {
            return this.activeModal == 'RegisterModal';
        },
    },
}
</script>
